import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  List,
  Row,
  Space,
  Switch,
  Upload,
  message,
} from "antd";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { url } from "../../config/global";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";

const layout = {
  labelCol: {
    lg: 8,
    md: 10,
  },
  wrapperCol: {
    lg: 14,
    md: 14,
  },
};

function Profile() {
  const [data, setData] = useState({
    username: "",
    full_name: "",
    email: "",
    number_phone: "",
    password: "",
    password_confirmation: "",
    photo: null,
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [twoFactorLoading, setTwoFactorLoading] = useState(false);
  const [twoFactorStatus, setTwoFactorStatus] = useState("inactive");
  useEffect(() => {
    getUser();
  }, []);
  const getUser = () => {
    Axios.get(`${url}/user/${sessionStorage.getItem("_id")}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setData({
          ...data,
          username: res.data.data.username,
          full_name: res.data.data.full_name,
          division: res.data.data.division,
          department: res.data.data.department,
          npk: res.data.data.npk,
          position: res.data.data.position,
          email: res.data.data.email,
          number_phone: res.data.data.number_phone,
          user_type: res.data.data.user_type,
          vendor_name: res.data.data.vendor_name,
          role_user_destinatio_id: res.data.data.role_user_destination_id,
          role_user_destination_name: res.data.data.role_user_destination,
          role_id: res.data.data.role_id,
          role_name: res.data.data.role_name,
          roles_apps_status: res.data.data.role_apps_status,
          roles_apps: res.data.data.role_apps,
          refer_id: res.data.data.refer_id,
          refer_name: res.data.data.refer_name,
          two_factor_enabled: res.data.data.two_factor_enabled,
          two_factor_methods: res.data.data.two_factor_methods || [],
        });
        setTwoFactorStatus(res.data.data.two_factor_enabled ? "active" : "inactive");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      });
  };

  const handleRemove = () => {
    setData({
      ...data,
      photo: null,
    });
  };

  const handleBeforeUpload = (files) => {
    setData({
      ...data,
      photo: files,
    });

    return false;
  };

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleChangeSelect = (name, value) => {
    setError(null);
    setData({
      ...data,
      [`${name}_id`]: value.value,
      [`${name}_name`]: value.label,
    });
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();

    fd.set("username", data.username);
    fd.set("full_name", data.full_name);
    fd.set("email", data.email);
    fd.set("number_phone", data.number_phone);
    fd.set("password", data.password);
    fd.set("password_confirmation", data.password_confirmation);
    fd.append("photo", data.photo);

    Axios.post(`${url}/user/${sessionStorage.getItem("_id")}/profile`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      }).finally(() => setLoading(false));
  };

  const handleReset = () => {
    setData({
      username: "",
      full_name: "",
      email: "",
      number_phone: "",
      password: "",
      password_confirmation: "",
      photo: null,
    });
  };

  const authHeaders = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  };

  const refreshTwoFactorMethods = (methods) => {
    setData((current) => ({
      ...current,
      two_factor_enabled: methods.length > 0,
      two_factor_methods: methods,
    }));
    setTwoFactorStatus(methods.length > 0 ? "active" : "inactive");
  };

  const updateTwoFactorMethods = (methods) => {
    setTwoFactorLoading(true);
    Axios.post(`${url}/2fa/methods`, { methods }, authHeaders)
      .then((res) => {
        message.success(res.data.message);
        refreshTwoFactorMethods(res.data.methods || []);
      })
      .catch((err) => {
        message.error(err.response ? err.response.data.message : "Gagal memperbarui metode 2 langkah.");
      })
      .finally(() => setTwoFactorLoading(false));
  };

  const disableTwoFactorMethod = (method) => {
    setTwoFactorLoading(true);
    Axios.post(`${url}/2fa/disable`, { method }, authHeaders)
      .then((res) => {
        message.success(res.data.message);
        refreshTwoFactorMethods(res.data.methods || []);
      })
      .catch((err) => {
        message.error(err.response ? err.response.data.message : "Gagal memperbarui 2 langkah.");
      })
      .finally(() => setTwoFactorLoading(false));
  };

  const handleTwoFactorStatusChange = (checked) => {
    const value = checked ? "active" : "inactive";
    setTwoFactorStatus(value);

    if (value === "inactive") {
      disableTwoFactorMethod("all");
      return;
    }

    if (!data.two_factor_enabled) {
      updateTwoFactorMethods(data.two_factor_methods && data.two_factor_methods.length > 0
        ? data.two_factor_methods
        : ['authenticator', 'email']);
    }
  };

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Layout.Content>
      <Row>
        <Col xs={24}>
          <Card className="body-data">
            <Form
              {...layout}
              labelAlign="left"
              name="control-hooks"
              onFinish={onSaveData}>
              <Row>
                <>
                  <Col xs={24} md={12}>
                    <Form.Item
                      required
                      label="Username"
                      validateStatus={error && error.username ? "error" : false}
                      help={
                        error && error.username ? error.username[0] : false
                      }>
                      <Input
                        value={data.username}
                        onChange={(e) =>
                          handleChange("username", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      required
                      label="Full Name"
                      validateStatus={
                        error && error.full_name ? "error" : false
                      }
                      help={
                        error && error.full_name ? error.full_name[0] : false
                      }>
                      <Input
                        value={data.full_name}
                        onChange={(e) =>
                          handleChange("full_name", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      required
                      label="NPK"
                      validateStatus={error && error.npk ? "error" : false}
                      help={error && error.npk ? error.npk[0] : false}>
                      <Input
                        value={data.npk}
                        disabled
                        onChange={(e) => handleChange("npk", e.target.value)}
                      />
                    </Form.Item>
                    <Form.Item
                      required
                      label="Division"
                      validateStatus={error && error.division ? "error" : false}
                      help={
                        error && error.division ? error.division[0] : false
                      }>
                      <Input
                        value={data.division}
                        disabled
                        onChange={(e) =>
                          handleChange("division", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      required
                      label="Department"
                      validateStatus={
                        error && error.department ? "error" : false
                      }
                      help={
                        error && error.department ? error.department[0] : false
                      }>
                      <Input
                        value={data.department}
                        disabled
                        onChange={(e) =>
                          handleChange("department", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      required
                      label="Position"
                      validateStatus={error && error.position ? "error" : false}
                      help={
                        error && error.position ? error.position[0] : false
                      }>
                      <Input
                        value={data.position}
                        disabled
                        onChange={(e) =>
                          handleChange("position", e.target.value)
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      required
                      label="Email"
                      validateStatus={error && error.email ? "error" : false}
                      help={error && error.email ? error.email[0] : false}>
                      <Input
                        value={data.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item
                      required
                      label="Phone Number"
                      validateStatus={
                        error && error.number_phone ? "error" : false
                      }
                      help={
                        error && error.number_phone
                          ? error.number_phone[0]
                          : false
                      }>
                      <Input
                        value={data.number_phone}
                        onChange={(e) =>
                          handleChange("number_phone", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item label="User Type">
                      <Input value={data.user_type} disabled />
                    </Form.Item>
                    <Form.Item label="Verifikasi 2 Langkah">
                      <Space direction="vertical">
                        <Switch
                          checked={twoFactorStatus === "active"}
                          loading={twoFactorLoading}
                          onChange={handleTwoFactorStatusChange}
                        />
                        <span>{twoFactorStatus === "active" ? "Aktif" : "Nonaktif"}</span>
                        {twoFactorStatus === "active" && (
                          <Checkbox.Group
                            value={data.two_factor_methods || []}
                            disabled={twoFactorLoading}
                            onChange={updateTwoFactorMethods}
                          >
                            <Space direction="vertical">
                              <Checkbox value="authenticator">QR Authenticator</Checkbox>
                              <Checkbox value="email">OTP Email</Checkbox>
                            </Space>
                          </Checkbox.Group>
                        )}
                      </Space>
                    </Form.Item>
                    <Form.Item label="Vendor">
                      <Input
                        value={
                          data.vendor_name !== "undefined"
                            ? data.vendor_name
                            : ""
                        }
                        disabled
                      />
                    </Form.Item>
                    <Form.Item label="Role">
                      <Input value={data.role_name} disabled />
                    </Form.Item>

                    <Form.Item
                      label="Change Password"
                      validateStatus={error && error.password ? "error" : false}
                      help={
                        error && error.password ? error.password[0] : false
                      }>
                      <Input.Password
                        value={data.password}
                        onChange={(e) =>
                          handleChange("password", e.target.value)
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      label="Confrim Password"
                      validateStatus={error && error.password ? "error" : false}
                      help={
                        error && error.password ? error.password[0] : false
                      }>
                      <Input.Password
                        value={data.password_confirmation}
                        onChange={(e) =>
                          handleChange("password_confirmation", e.target.value)
                        }
                      />
                    </Form.Item>

                    <Form.Item name="photo" label="Photo">
                      <>
                        <Upload
                          onRemove={handleRemove}
                          beforeUpload={handleBeforeUpload}
                          fileList={[]}>
                          <Button>
                            Upload <UploadOutlined />
                          </Button>
                        </Upload>
                        {data.photo && (
                          <List>
                            <List.Item
                              actions={[
                                <Button
                                  onClick={handleRemove}
                                  type="danger"
                                  ghost>
                                  <DeleteOutlined />
                                </Button>,
                              ]}>
                              <List.Item.Meta description={data.photo.name} />
                            </List.Item>
                          </List>
                        )}
                      </>
                    </Form.Item>
                  </Col>

                  <Row type="flex" gutter={[10, 20]} justify="space-around">
                    <Col>
                      <Button
                        loading={loading}
                        type="primary"
                        htmlType="submit"
                        className="mr-button btn-success">
                        Submit
                      </Button>
                      <Button htmlType="reset" onClick={handleReset}>
                        Reset
                      </Button>
                    </Col>
                  </Row>
                </>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </Layout.Content>
  );
}

export default Profile;
